/*  iceberg-ui  */
import { Icon } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { Box, Chip } from '@mui/material';

/* Shared */
import { FontSizes, RiskLevel } from 'application/Shared/Constants';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/*  Components  */
import ObjectPicker from './Components/ObjectPicker';

const visualPayload = (t) => ({
    [RiskLevel.Alert]: (
        <Chip
            icon={
                <Box sx={{ lineHeight: 0 }}>
                    <Icon size={FontSizes[2]} src="Notification" />
                </Box>
            }
            sx={{
                '& .MuiChip-icon': {
                    color: 'risk.icon.alert'
                },
                '& .MuiChip-label': {
                    paddingX: '8px',
                    paddingY: '2px'
                },
                backgroundColor: 'risk.backgroundColor.alert',
                border: '1px solid',
                borderColor: 'risk.borderColor.alert',
                color: 'risk.textColor.alert'
            }}
            size="small"
            label={t('Common.alert')}
        />
    ),
    [RiskLevel.Critical]: (
        <Chip
            icon={
                <Box sx={{ lineHeight: 0 }}>
                    <Icon size={FontSizes[2]} src="WarningTriangleFilled" />
                </Box>
            }
            sx={{
                '& .MuiChip-icon': {
                    color: 'risk.icon.critical'
                },
                '& .MuiChip-label': {
                    paddingX: '8px',
                    paddingY: '2px'
                },
                backgroundColor: 'risk.backgroundColor.critical',
                border: '1px solid',
                borderColor: 'risk.borderColor.critical',
                color: 'risk.textColor.critical'
            }}
            size="small"
            label={t('Common.critical')}
        />
    ),
    [RiskLevel.High]: (
        <Chip
            icon={
                <Box sx={{ lineHeight: 0 }}>
                    <Icon size={FontSizes[2]} src="Warning" />
                </Box>
            }
            sx={{
                '& .MuiChip-icon': {
                    color: 'risk.icon.high'
                },
                '& .MuiChip-label': {
                    paddingX: '8px',
                    paddingY: '2px'
                },
                backgroundColor: 'risk.backgroundColor.high',
                border: '1px solid',
                borderColor: 'risk.borderColor.high',
                color: 'risk.textColor.high'
            }}
            size="small"
            label={t('Common.high')}
        />
    ),
    [RiskLevel.Medium]: (
        <Chip
            icon={
                <Box sx={{ lineHeight: 0 }}>
                    <Icon size={FontSizes[2]} src="Brightness" />
                </Box>
            }
            sx={{
                '& .MuiChip-icon': {
                    color: 'risk.icon.medium'
                },
                '& .MuiChip-label': {
                    paddingX: '8px',
                    paddingY: '2px'
                },
                backgroundColor: 'risk.backgroundColor.medium',
                border: '1px solid',
                borderColor: 'risk.borderColor.medium',
                color: 'risk.textColor.medium'
            }}
            size="small"
            label={t('Common.medium')}
        />
    ),
    // eslint-disable-next-line sort-keys-fix/sort-keys-fix
    [RiskLevel.Low]: (
        <Chip
            icon={
                <Box sx={{ lineHeight: 0 }}>
                    <Icon size={FontSizes[2]} src="Check" />
                </Box>
            }
            sx={{
                '& .MuiChip-icon': {
                    color: 'risk.icon.low'
                },
                '& .MuiChip-label': {
                    paddingX: '8px',
                    paddingY: '2px'
                },
                backgroundColor: 'risk.backgroundColor.low',
                border: '1px solid',
                borderColor: 'risk.borderColor.low',
                color: 'risk.textColor.low'
            }}
            size="small"
            label={t('Common.low')}
        />
    ),
    [RiskLevel.Safe]: (
        <Chip
            icon={
                <Box sx={{ lineHeight: 0 }}>
                    <Icon size={FontSizes[2]} src="ValidUser" />
                </Box>
            }
            sx={{
                '& .MuiChip-icon': {
                    color: 'risk.icon.safe'
                },
                '& .MuiChip-label': {
                    paddingX: '8px',
                    paddingY: '2px'
                },
                backgroundColor: 'risk.backgroundColor.safe',
                border: '1px solid',
                borderColor: 'risk.borderColor.safe',
                color: 'risk.textColor.safe'
            }}
            size="small"
            label={t('Common.safe')}
        />
    )
});

export const RiskPicker = (props) => {
    const { t } = useTranslation();
    const objectPayload = {};
    const translatedVisualPayload = visualPayload(t);
    Object.keys(translatedVisualPayload).forEach((risk) => {
        objectPayload[risk] = {
            display: risk,
            displayVisualOnly: translatedVisualPayload[risk],
            id: risk
        };
    });

    const { value, visualOnly, rerender } = props;

    if ((value === undefined || !value) && visualOnly) {
        return null;
    }

    return (
        <ObjectPicker
            {...props}
            rerender={rerender}
            disableClearable
            objectPayload={objectPayload}
            objectNameField="display"
            objectNameFieldVisualOnly="displayVisualOnly"
            visualOnlyDefault={visualPayload.safe}
        />
    );
};
